import ListItem, { ListItemMetadata } from "../ListItem/ListItem";
import "./ListItemGroup.scss";
import {
  CalendarBlankIcon,
  GridPresetOffsetWideContent,
  GridPresetWideList,
  GridRow,
  HideFor,
  InfoSmallIcon,
} from "/App.Components";
import { createSpreadableBem } from "/Helpers/createBem";
import { DesignTheme } from "/Models/Generated/DesignTheme";

import { NewsListItemProps } from "/Models/Generated/NewsListItemProps";
import { NewsListSectionProps } from "/Models/Generated/NewsListSectionProps";

interface Props extends NewsListSectionProps {
  overrideGetMetaDataItems?: (
    item: NewsListItemProps
  ) => ListItemMetadata | undefined;
  showLabel?: boolean;
  theme?: DesignTheme;
}

const NewsListItemGroup: React.FC<Props> = ({
  sectionHeading,
  items,
  overrideGetMetaDataItems,
  showLabel,
  theme,
}) => {
  const getMetadataItems = (item: NewsListItemProps) =>
    overrideGetMetaDataItems
      ? overrideGetMetaDataItems(item)
      : {
          firstRow: item.published && (
            <InfoSmallIcon text={item.published} icon={CalendarBlankIcon} />
          ),
        };

  const bem = createSpreadableBem("list-item-group-norad");
  return (
    <li {...bem("")}>
      <GridRow>
        <GridPresetOffsetWideContent>
          {sectionHeading && (
            <>
              <h2 {...bem("__section-heading")}>{sectionHeading}</h2>
              <GridPresetWideList>
                <HideFor desktop desktopMedium desktopLargeUp>
                  <div
                    {...bem("__section-heading-divider", {
                      "--insight": theme === DesignTheme.Insight,
                    })}
                  ></div>
                </HideFor>
              </GridPresetWideList>
            </>
          )}
        </GridPresetOffsetWideContent>

        <ol {...bem("__items")}>
          {items &&
            items.map((item, idx) => (
              <ListItem
                label={showLabel ? item.label : undefined}
                link={item.link}
                key={"list-item" + idx}
                metadataItems={getMetadataItems(item)}
                image={item.picture}
                heading={item.heading}
                published={item.published}
                categoryTags={item.categoryTags}
                theme={theme}
              />
            ))}
        </ol>
      </GridRow>
      <GridRow>
        <GridPresetWideList>
          <HideFor mobile tablet>
            <div
              {...bem("__divider", {
                "--insight": theme === DesignTheme.Insight,
              })}
            ></div>
          </HideFor>
        </GridPresetWideList>
      </GridRow>
    </li>
  );
};

export default NewsListItemGroup;
